import { render, staticRenderFns } from "./Hook.vue?vue&type=template&id=649e43dc&"
import script from "./Hook.vue?vue&type=script&lang=js&"
export * from "./Hook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports